import React, { useState } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import { FaCopy, FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';

const PasswordField = ({ label, value, available, color }) => {
  const [visible, setVisible] = useState(false);

  const copiar = () => {
    if (!value) return;
    navigator.clipboard.writeText(value).then(() => {
      toast.success('Copiado!', { autoClose: 1500 });
    });
  };

  return (
    <div className="password-field-row mb-2">
      <div
        className="password-field-label d-flex align-items-center"
        style={{ gap: '8px', width: '150px', flexShrink: 0 }}
      >
        <span
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: available ? color : '#ddd',
            display: 'inline-block',
            flexShrink: 0,
            boxShadow: available ? '0 0 6px ' + color + '44' : 'none',
          }}
        />
        <strong style={{ fontSize: '0.85rem', color: '#1a2332' }}>{label}</strong>
      </div>
      <div
        className="password-field-controls d-flex align-items-center"
        style={{ gap: '8px' }}
      >
        {available ? (
          <>
            <FormControl
              readOnly
              value={
                visible
                  ? value
                  : '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022'
              }
              style={{
                fontFamily: "'Courier New', monospace",
                maxWidth: '200px',
                backgroundColor: '#fff',
                border: '1px solid #e0e4ea',
                borderRadius: '8px',
                cursor: 'default',
                userSelect: visible ? 'text' : 'none',
                fontSize: '0.88rem',
                letterSpacing: visible ? '0' : '2px',
              }}
              size="sm"
              tabIndex={-1}
            />
            <Button
              variant="link"
              size="sm"
              onClick={() => setVisible(!visible)}
              style={{
                padding: '4px 8px',
                color: '#0747a6',
                borderRadius: '6px',
                fontSize: '0.88rem',
              }}
              title={visible ? 'Ocultar' : 'Revelar'}
            >
              {visible ? <FaEyeSlash /> : <FaEye />}
            </Button>
            <Button
              variant="link"
              size="sm"
              onClick={copiar}
              style={{
                padding: '4px 8px',
                color: '#0747a6',
                borderRadius: '6px',
                fontSize: '0.88rem',
              }}
              title="Copiar"
            >
              <FaCopy />
            </Button>
          </>
        ) : (
          <span style={{ color: '#bbb', fontStyle: 'italic', fontSize: '0.82rem' }}>
            Sem acesso
          </span>
        )}
      </div>
    </div>
  );
};

export default PasswordField;
